import { Medico } from "../../medico/medico";
import { ProcedimentoAgendaPk } from "./pks/procedimento-agenda-pk";
import { ProcedimentoAgendaTomada } from "./procedimento-agenda-tomada";

export class ProcedimentoAgenda {

    pk: ProcedimentoAgendaPk = new ProcedimentoAgendaPk();

    quantidadeAtdGeral: number = 0;

    atdIdadeMinima: number = 0;

    atdIdadeMaxima: number = 0;

    tomadas: Array<ProcedimentoAgendaTomada> = [];

    medico: Medico = new Medico();

    dataInicioAgenda: Date = new Date();

    constructor() {
    }
}
